<div mat-dialog-title>Search products
    <div class="dialog-close-button">
        <a id="close" (click)="onClose()">
            <img src="/assets/images/close-popup.png">
        </a>
    </div>
</div>
<div mat-dialog-content cdkFocusInitial>
    <p class="helpText">The basic search feature uses your specific search to help refine your results. The advanced search allows you to further
        narrow results by selecting both search type and condition. ParMed’s search system is database driven so the product
        name must be spelled correctly in order for search results to appear. If you are having difficulty finding your product,
        please call your Sales Representative or Customer Service at {{footerData.InquiryNumber}}.</p>
    <strong>BASIC SEARCH</strong>
    <ul>
        <li>Item Number</li>
        <li>NDC Number</li>
        <li>UPC</li>
        <li>Brand Name</li>
        <li>Generic Name (Description)</li>
    </ul>
    <strong>ADVANCED SEARCH</strong>
    <ul>
        <li>Item Number</li>
        <li>NDC Number</li>
        <li>UPC</li>
        <li>Brand Name</li>
        <li>Generic Name (Description)</li>
        <li>Manufacturer</li>
    </ul>
    <strong>SEARCH CONDITIONS</strong>
    <ul>
        <li>Starts With</li>
        <li>Contains</li>
        <li>Equals</li>
    </ul>
</div>
<div mat-dialog-actions>
    <button id="btn-close" mat-raised-button [mat-dialog-close]="true">Close</button>
</div>